module.exports = __webpack_public_path__ + "static/media/light-theme-alerts.190e1220.svg";